"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordScreen = void 0;
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Box_1 = __importDefault(require("@mui/material/Box"));
var contexts_1 = require("../../contexts");
var ForgotPasswordScreenBase_1 = require("./ForgotPasswordScreenBase");
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
var styles_1 = require("../../styles");
var useErrorManager_1 = require("../../contexts/ErrorContext/useErrorManager");
/**
 * Component renders a screen with forgot password for support with the application.
 *
 * @param emailLabel label for the email field
 * @param initialEmailValue initial value for the email text field
 * @param emailValidator function used to test the input for valid formatting
 * @param showSuccessScreen used to determine whether to show a success screen after the form is submitted
 * @param slots used for ForgotPasswordScreen SuccessScreen
 * @param slotProps applied to slot from SuccessScreen
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 * @param WorkflowCardHeaderProps props that will be passed to the WorkflowCardHeader component
 * @param WorkflowCardInstructionProps props that will be passed to the WorkflowCardInstructions component
 * @param WorkflowCardActionsProps props that will be passed to the WorkflowCardActions component
 * @param errorDisplayConfig configuration for customizing how errors are displayed
 * @param emailTextFieldProps props to pass to the email field.
 *
 * @category Component
 */
var ForgotPasswordScreen = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, contexts_1.useAuthContext)(), actions = _a.actions, navigate = _a.navigate, routeConfig = _a.routeConfig;
    var _b = (0, useErrorManager_1.useErrorManager)(), triggerError = _b.triggerError, errorManagerConfig = _b.errorManagerConfig;
    var errorDisplayConfig = __assign(__assign(__assign({}, errorManagerConfig), props.errorDisplayConfig), { onClose: function () {
            if (props.errorDisplayConfig && props.errorDisplayConfig.onClose)
                props.errorDisplayConfig.onClose();
            if (errorManagerConfig.onClose)
                errorManagerConfig === null || errorManagerConfig === void 0 ? void 0 : errorManagerConfig.onClose();
        } });
    var _c = (0, react_1.useState)(''), emailInput = _c[0], setEmailInput = _c[1];
    var _d = (0, react_1.useState)(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = (0, react_1.useState)(false), showSuccessScreen = _e[0], setShowSuccessScreen = _e[1];
    var EMAIL_REGEX = /^[A-Z0-9._%+'-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    var handleOnNext = (0, react_1.useCallback)(function (email) { return __awaiter(void 0, void 0, void 0, function () {
        var _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, actions.forgotPassword(email)];
                case 1:
                    _a.sent();
                    if (props.showSuccessScreen === false) {
                        navigate(routeConfig.LOGIN);
                    }
                    else {
                        setShowSuccessScreen(true);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    _error_1 = _a.sent();
                    triggerError(_error_1);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [actions, triggerError]);
    var _f = props.emailLabel, emailLabel = _f === void 0 ? t('bluiCommon:LABELS.EMAIL') : _f, _g = props.contactPhone, contactPhone = _g === void 0 ? '1-800-123-4567' : _g, initialEmailValue = props.initialEmailValue, description = props.description, _h = props.responseTime, responseTime = _h === void 0 ? t('bluiAuth:FORGOT_PASSWORD.RESPONSE_TIME') : _h, _j = props.emailValidator, emailValidator = _j === void 0 ? function (email) {
        return new RegExp(EMAIL_REGEX).test(email) ? true : t('bluiCommon:MESSAGES.EMAIL_ENTRY_ERROR');
    } : _j, WorkflowCardBaseProps = props.WorkflowCardBaseProps, WorkflowCardHeaderProps = props.WorkflowCardHeaderProps, WorkflowCardInstructionProps = props.WorkflowCardInstructionProps, WorkflowCardActionsProps = props.WorkflowCardActionsProps, _k = props.showSuccessScreen, enableSuccessScreen = _k === void 0 ? true : _k, _l = props.slots, slots = _l === void 0 ? {} : _l, _m = props.slotProps, slotProps = _m === void 0 ? {} : _m, emailTextFieldProps = props.emailTextFieldProps;
    var workflowCardBaseProps = __assign({ loading: isLoading }, WorkflowCardBaseProps);
    var workflowCardInstructionProps = __assign({ instructions: description ? (react_1.default.createElement(Box_1.default, { sx: { px: { md: 3, xs: 2 }, pt: 2 } },
            " ",
            description(responseTime),
            " ")) : (react_1.default.createElement(Typography_1.default, { sx: { px: { md: 3, xs: 2 }, pt: 2 } },
            react_1.default.createElement(react_i18next_1.Trans, { i18nKey: 'bluiAuth:FORGOT_PASSWORD.INSTRUCTIONS_ALT', values: { phone: contactPhone, time: responseTime } },
                "Please enter your email, we will respond in ",
                react_1.default.createElement("b", null, responseTime),
                ". For urgent issues please call",
                ' ',
                react_1.default.createElement(Typography_1.default, { component: "a", href: "tel:".concat(contactPhone), sx: styles_1.LinkStyles }, contactPhone),
                '.'))) }, WorkflowCardInstructionProps);
    var workflowCardHeaderProps = __assign({ title: t('bluiAuth:HEADER.FORGOT_PASSWORD') }, WorkflowCardHeaderProps);
    var workflowCardActionsProps = __assign(__assign({ showNext: true, showPrevious: true, nextLabel: t('bluiCommon:ACTIONS.SUBMIT'), previousLabel: t('bluiCommon:ACTIONS.BACK'), canGoNext: true, canGoPrevious: true }, WorkflowCardActionsProps), { onNext: function (data) {
            var _a;
            setEmailInput(data.email);
            void handleOnNext(data.email);
            (_a = WorkflowCardActionsProps === null || WorkflowCardActionsProps === void 0 ? void 0 : WorkflowCardActionsProps.onNext) === null || _a === void 0 ? void 0 : _a.call(WorkflowCardActionsProps);
        }, onPrevious: function () {
            var _a;
            navigate(routeConfig.LOGIN);
            (_a = WorkflowCardActionsProps === null || WorkflowCardActionsProps === void 0 ? void 0 : WorkflowCardActionsProps.onPrevious) === null || _a === void 0 ? void 0 : _a.call(WorkflowCardActionsProps);
        } });
    return (react_1.default.createElement(ForgotPasswordScreenBase_1.ForgotPasswordScreenBase, { WorkflowCardBaseProps: workflowCardBaseProps, WorkflowCardHeaderProps: workflowCardHeaderProps, WorkflowCardInstructionProps: workflowCardInstructionProps, WorkflowCardActionsProps: workflowCardActionsProps, emailLabel: emailLabel, initialEmailValue: initialEmailValue, emailValidator: emailValidator, emailTextFieldProps: emailTextFieldProps, showSuccessScreen: enableSuccessScreen && showSuccessScreen, slots: slots, slotProps: {
            SuccessScreen: __assign({ icon: react_1.default.createElement(CheckCircle_1.default, { color: 'primary', sx: { fontSize: 100, mb: 5 } }), messageTitle: t('bluiCommon:MESSAGES.EMAIL_SENT'), message: (react_1.default.createElement(Box_1.default, { sx: {
                        overflow: 'hidden',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                    }, component: 'span' },
                    react_1.default.createElement(react_i18next_1.Trans, { i18nKey: 'bluiAuth:FORGOT_PASSWORD.LINK_SENT_ALT', values: { email: emailInput } },
                        "Link has been sent to ",
                        react_1.default.createElement("b", null, emailInput),
                        "."))), WorkflowCardHeaderProps: {
                    title: t('bluiAuth:HEADER.FORGOT_PASSWORD'),
                }, WorkflowCardActionsProps: {
                    showNext: true,
                    nextLabel: t('bluiCommon:ACTIONS.DONE'),
                    canGoNext: true,
                    fullWidthButton: true,
                    onNext: function () {
                        navigate(routeConfig.LOGIN);
                    },
                } }, slotProps.SuccessScreen),
        }, errorDisplayConfig: errorDisplayConfig }));
};
exports.ForgotPasswordScreen = ForgotPasswordScreen;
